var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import styles from './typography.module.css';
import clsx from 'clsx';
var variantComponentMapping = {
    default: 'span',
    address: 'address',
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    paragraph: 'p',
};
var componentClassNameMapping = {
    span: 'text',
    address: 'address',
    p: 'paragraph',
    h1: 'heading1',
    h2: 'heading2',
    h3: 'heading3',
    h4: 'heading4',
    h5: 'heading5',
    h6: 'heading6',
};
export var Typography = function (_a) {
    var children = _a.children, _b = _a.variant, variant = _b === void 0 ? 'default' : _b, _c = _a.type, type = _c === void 0 ? 'default' : _c, size = _a.size, weight = _a.weight, lineHeight = _a.lineHeight, _d = _a.paragraph, paragraph = _d === void 0 ? false : _d, _e = _a.gutterBottom, gutterBottom = _e === void 0 ? false : _e, _f = _a.noWrap, noWrap = _f === void 0 ? false : _f, _g = _a.preWrap, preWrap = _g === void 0 ? false : _g, _h = _a.noMargin, noMargin = _h === void 0 ? false : _h, component = _a.component;
    var Component = component !== null && component !== void 0 ? component : (paragraph ? 'p' : variantComponentMapping[variant]);
    var className = componentClassNameMapping[Component];
    var isHeading = variant.startsWith('h');
    return (_jsx(Component, __assign({ className: clsx(isHeading ? styles['heading'] : styles['base'], styles[className], styles[type], size && styles["size__".concat(size)], weight && styles["weight__".concat(weight)], lineHeight && styles["lineHeight__".concat(lineHeight)], gutterBottom && 'gutterBottom', noWrap && styles.noWrap, preWrap && styles.preWrap, noMargin && styles.noMargin) }, { children: children })));
};
export default Typography;
